import React, { Component } from "react";
import EmbedViewer from "./EmbedViewer";

// Carousel propio en vez de Flickity: Flickity mide las celdas antes de que
// carguen las imágenes y los usos internos lo compensan con tuning manual
// (disableImagesLoaded, reloadOnUpdate, refs) que acá no podríamos depurar,
// porque esto corre dentro de la página de un cliente. El requisito son 3
// slides con prev/next: no amerita la dependencia.
const SWIPE_MIN_PX = 40;

class EmbedCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = { index: 0 };
    this.trackRef = React.createRef();
    this.touchStartX = null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.index !== this.state.index) {
      this.pauseHiddenVideos();
    }
  }

  // Sin esto el audio de una diapositiva sigue sonando fuera de pantalla.
  pauseHiddenVideos() {
    const track = this.trackRef.current;
    if (!track) return;
    const slides = track.children;
    for (let i = 0; i < slides.length; i++) {
      if (i === this.state.index) continue;
      const videos = slides[i].getElementsByTagName("video");
      for (let v = 0; v < videos.length; v++) videos[v].pause();
    }
  }

  go = next => {
    const total = this.props.items.length;
    this.setState({ index: ((next % total) + total) % total });
  };

  handleKeyDown = e => {
    if (e.key === "ArrowRight") {
      e.preventDefault();
      this.go(this.state.index + 1);
    } else if (e.key === "ArrowLeft") {
      e.preventDefault();
      this.go(this.state.index - 1);
    }
  };

  handleTouchStart = e => {
    this.touchStartX = e.changedTouches[0].clientX;
  };

  handleTouchEnd = e => {
    if (this.touchStartX === null) return;
    const delta = e.changedTouches[0].clientX - this.touchStartX;
    this.touchStartX = null;
    if (Math.abs(delta) < SWIPE_MIN_PX) return;
    this.go(this.state.index + (delta < 0 ? 1 : -1));
  };

  render() {
    const { items } = this.props;
    const { index } = this.state;
    const many = items.length > 1;

    return (
      <div
        className="bk-embed__carousel"
        tabIndex={0}
        onKeyDown={this.handleKeyDown}
        onTouchStart={this.handleTouchStart}
        onTouchEnd={this.handleTouchEnd}
      >
        <div
          className="bk-embed__track"
          ref={this.trackRef}
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {items.map((item, i) => (
            <div className="bk-embed__slide" key={item.data._id || i}>
              <EmbedViewer media={item.media} data={item.data} />
            </div>
          ))}
        </div>

        {many && (
          <button
            type="button"
            className="bk-embed__nav bk-embed__nav--prev"
            aria-label="Anterior"
            onClick={() => this.go(index - 1)}
          >
            {"‹"}
          </button>
        )}
        {many && (
          <button
            type="button"
            className="bk-embed__nav bk-embed__nav--next"
            aria-label="Siguiente"
            onClick={() => this.go(index + 1)}
          >
            {"›"}
          </button>
        )}

        {many && (
          <div className="bk-embed__dots">
            {items.map((item, i) => (
              <button
                type="button"
                key={item.data._id || i}
                className={
                  i === index
                    ? "bk-embed__dot bk-embed__dot--active"
                    : "bk-embed__dot"
                }
                aria-label={`Ir a la imagen ${i + 1}`}
                onClick={() => this.go(i)}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default EmbedCarousel;
